// @flow

import React from 'react';
export function PrimaryIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.0859 9.88175C5.73629 9.95918 5.37291 10 5 10C2.23858 10 0 7.76142 0 5C0 2.23858 2.23858 0 5 0C7.70083 0 9.90151 2.14142 9.99679 4.819L14.3739 5.54852C14.8853 4.62513 15.8697 4 17 4C18.6569 4 20 5.34315 20 7C20 8.65685 18.6569 10 17 10C16.6795 10 16.3708 9.94975 16.0812 9.8567L13.2151 13.6198C13.7083 14.2849 14 15.1084 14 16C14 18.2091 12.2091 20 10 20C7.79086 20 6 18.2091 6 16C6 14.7625 6.56194 13.6563 7.44455 12.9226L6.0859 9.88175ZM7.91164 9.06524L9.25393 12.0695C9.49564 12.0239 9.74504 12 10 12C10.5924 12 11.1548 12.1288 11.6606 12.3599L14.4905 8.64447C14.2712 8.31052 14.1168 7.93016 14.0451 7.52132L9.66928 6.79201C9.31623 7.71135 8.69948 8.49997 7.91164 9.06524Z"
      />
    </svg>
  );
}
